import type { ListingAudience } from '../analytics/client';
import { B_SIDE_VISIBLE_FLAG } from '../analytics/client';
import ListingVisibilityBadge from './ListingVisibilityBadge';
import { previewDestinations } from '../destinations';

/**
 * Exact internal domains. The listing flag already targets these; this is the second lock,
 * so a flag broadened by mistake still lists an internal prototype to nobody else.
 * B-Side's own Worker re-checks a verified address before serving anything.
 */
export function internalBSideEmail(email: unknown): boolean {
  return typeof email === 'string' && /^[^\s@]+@(240tutoring|240certification)\.com$/i.test(email.trim());
}

export default function BSideListing({ listing, onOpen }: { listing?: { visible: boolean; audience: ListingAudience } | null; onOpen: () => void }) {
  if (!listing?.visible) return null;
  return <section className="preview-featured" aria-labelledby="b-side-heading">
    <div className="preview-featured-content">
      <span className="preview-badge">Internal prototype</span>
      <h2 id="b-side-heading">B-Side</h2>
      <ListingVisibilityBadge audience={listing.audience} flagKey={B_SIDE_VISIBLE_FLAG} />
      <p className="preview-summary">The other side of 240. Listen to three existing tracks with timed lyrics.</p>
      <div className="preview-actions"><a className="preview-notify" href={previewDestinations(window.location.hostname).bSide} onClick={onOpen}>Open B-Side</a></div>
    </div>
  </section>;
}
